module.exports = __webpack_public_path__ + "sd.svg?d702bafe1580a1d29a20610f75f28964";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/sd.svg
// module id = 1346
// module chunks = 0